import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../../createApiConfig'

export const tMDistriputionApi = createApi({
  reducerPath: 'tMDistriputionApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['TaskDistribution','DistributionWeight'],
  endpoints: builder => ({
    getTaskDistributions: builder.query({
      query: params => ({
        url: '/task-distribution/',
        method: 'GET',
        params
      }),
      providesTags: ['TaskDistribution']
    }),

    createTaskDistribution: builder.mutation({
      query: body => ({
        url: '/task-distribution/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['TaskDistribution']
    }),

    getTaskDistributionById: builder.query({
      query: id => ({
        url: `/task-distribution/${id}/`,
        method: 'GET'
      }),
      invalidatesTags: ['TaskDistribution']
    }),

    updateTaskDistribution: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/task-distribution/${id}/`,
        method: 'PUT',
        body
      }),
      invalidatesTags: ['TaskDistribution']
    }),

    patchTaskDistribution: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/task-distribution/${id}/`,
        method: 'PATCH',
        body
      }),
      invalidatesTags: ['TaskDistribution']
    }),

    deleteTaskDistribution: builder.mutation({
      query: id => ({
        url: `/task-distribution/${id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ['TaskDistribution']
    }),

    getDistribute: builder.query({
      query: params => ({
        url: '/task-distribution/distribute/',
        method: 'GET',
        params
      }),
      providesTags: ['TaskDistribution']
    }),

    executeDistribution: builder.mutation({
      query: body => ({
        url: '/task-distribution/distribute/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['TaskDistribution'],
    }),

    getWeights: builder.query({
      query: params => ({
        url: '/task-distribution/weights/',
        method: 'GET',
        params
      }),
      providesTags: ['DistributionWeight']
    }),

    updateWeights: builder.mutation({
      query: body => ({
        url: '/task-distribution/weights/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['DistributionWeight']
    })
  })
})

export const {
  useGetTaskDistributionsQuery,
  useCreateTaskDistributionMutation,
  useGetTaskDistributionByIdQuery,
  useUpdateTaskDistributionMutation,
  usePatchTaskDistributionMutation,
  useDeleteTaskDistributionMutation,
  useGetDistributeQuery,
  useExecuteDistributionMutation,
  useGetWeightsQuery,
  useUpdateWeightsMutation
} = tMDistriputionApi
